export enum MemberStatusTabKeysEnum {
  Active = 'active',
  Paid = 'paid',
  NotPaid = 'notPaid',
  NewMember = 'newMember',
  NotMember = 'notMember',
}
